<template>
  <v-col>
    <!-- sales data table -->
    <sales-table
      :key="index"
      text-color="info"
      url-api="/order?filter=salling"
      :headers="headers"
    >
      <!-- New Sale slot -->
      <template v-slot:urlCreate="">
        <v-btn
          class="info"
          @click.prevent="
            $router.push({
              name: 'PosSale',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          New Sale
        </v-btn>
      </template>
      <!-- end -->
      <!-- Sale transaction -->
      <template v-slot:key="{ item }">
        <div class="white pa-1">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-img
                v-bind="attrs"
                :src="item.barcode"
                lazy-src="/storage/default_img/no_image.png"
                aspect-ratio="1"
                max-width="100"
                max-height="15"
                v-on="on"
              />
            </template>
            <span>TRX #{{ item.key }}</span>
          </v-tooltip>
        </div>
      </template>
      <!-- end -->

      <!-- Sale method -->
      <template v-slot:method="{ item }">
        {{ item.method ? "Live" : "Due" }}
      </template>
      <!-- end -->

      <!-- Sold QTY -->
      <template v-slot:qty="{ item }">
        {{ item.totalItems }}
      </template>
      <!-- end -->

      <!-- Sale Sub total -->
      <template v-slot:subTotal="{ item }">
        {{ item.subTotal | currency }}
      </template>
      <!-- end -->

      <!-- Sale cost -->
      <template v-slot:cost="{ item }">
        {{ item.cost | currency }}
      </template>
      <!-- end -->

      <!-- Sale Profit -->
      <template v-slot:profit="{ item }">
        <span
          :class="item.profit > 0 ? 'green--text' : 'red--text'"
        >{{ item.profit | currency }}
        </span>
      </template>
      <!-- end -->

      <!-- Total Amount -->
      <template v-slot:totalAmount="{ item }">
        {{ item.totalAmount | currency }}
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <v-menu
          offset-y
          transition="scale-transition"
          open-on-hover
        >
          <template v-slot:activator="{ on: menu }">
            <v-icon
              class="info--text"
              v-on="{ ...menu }"
            >
              mdi-more
            </v-icon>
          </template>
          <v-list>
            <v-list-item
              @click.prevent="
                $router.push({
                  name: 'SaleDetail',
                  params: { id: item.id },
                })
              "
            >
              <v-list-item-title>
                <v-icon>mdi-eye</v-icon>
                Details
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item
              @click.prevent="
                $router.push({
                  name: 'PrintSale',
                  params: { id: item.id },
                })
              "
            >
              <v-list-item-title>
                <v-icon>mdi-printer</v-icon>
                Print Invoice
              </v-list-item-title>
            </v-list-item>
          </v-list>

          <v-list>
            <v-list-item
              @click.prevent="
                $router.push({
                  name: 'ShippingAddress',
                  params: { id: item.id },
                })
              "
            >
              <v-list-item-title>
                <v-icon>mdi-truck-fast</v-icon>
                Print Shipping card
              </v-list-item-title>
            </v-list-item>
          </v-list>

          <v-list>
            <v-list-item
              @click.prevent="
                $router.push({
                  name: 'PosSale',
                  params: { trax: item.key },
                })
              "
            >
              <v-list-item-title>
                <v-icon>mdi-cart-off</v-icon>
                Refund
              </v-list-item-title>
            </v-list-item>
          </v-list>

          <v-list>
            <v-list-item @click="exportInvoice(item.id)">
              <v-list-item-title>
                <v-icon>mdi-file-pdf</v-icon>
                Export Invoice
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item @click="showMailingDialog(item)">
              <v-list-item-title>
                <v-icon>mdi-email</v-icon>
                Mail to
              </v-list-item-title>
            </v-list-item>
          </v-list>

          <v-list>
            <v-list-item @click="warningSaleRemove(item)">
              <v-list-item-title>
                <v-icon>mdi-delete</v-icon>
                Remove
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <!-- end columnActions -->
    </sales-table>

    <!-- end data table -->

    <!-- Sale remove confirmation dialog  -->
    <v-dialog
      v-model="saleRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning: Are you sure to remove ?
        </v-card-title>
        <v-card-text>
          Note: Sold item quantity will not be reverse.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="saleRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeSale"
          >
            Remove Sale
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->

    <!-- Sale mailing dialog  -->
    <v-dialog
      v-model="isMailing"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title class="headline">
          Mail Sale Invoice
        </v-card-title>
        <v-card-text>
          <v-col cols="12">
            <v-text-field
              v-model="mailBox.emailTo"
              hide-details="auto"
              label="Enter email"
              outlined
              type="email"
              dense
            />
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="isMailing = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="darken-1"
            text
            :disabled="!mailBox.emailTo"
            @click="emailInvocie"
          >
            Send Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import SalesTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "sales-table": SalesTable,
  },
  data() {
    return {
      isMailing: false,
      mailBox: {},
      saleRemoveWarning: false,
      sale: {},
      index: 1,
      headers: [
        {
          text: "Created At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "TRX ID",
          sortable: true,
          value: "key",
          slot: "key",
          searchables: true,
        },
        {
          text: "Sold",
          sortable: true,
          slot: "qty",
          value: "totalItems",
          formatMoney: true,
        },

        {
          text: "Method",
          sortable: true,
          slot: "method",
          value: "method",
        },

        {
          text: "Cost",
          sortable: true,
          slot: "cost",
          value: "cost",
        },
        {
          text: "Price",
          sortable: true,
          slot: "subTotal",
          value: "subTotal",
        },
        {
          text: "Profit",
          sortable: true,
          slot: "profit",
          value: "profit",
        },

        {
          text: "Total Amount",
          sortable: true,
          slot: "totalAmount",
          value: "totalAmount",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    exportInvoice(invoice) {
      Event.$emit("exportPdfSale", invoice);
    },

    showMailingDialog(order) {
      this.$data.isMailing = true;
      this.$data.mailBox.order = order;
    },
    resetMailer() {
      this.$data.isMailing = false;
      this.$data.mailBox.emailTo = null;
    },
    emailInvocie() {
      const form = this.$data.mailBox;
      const id = form.order.id;
      window.axios.post("/email-sale-invoice/" + id, form).then((response) => {
        this.feedback(response.data.message);
        this.resetMailer();
      });
    },
    removeSale() {
      window.axios.delete("/order/" + this.$data.sale.id).then((response) => {
        this.$data.saleRemoveWarning = false;
        this.$data.index++;
        this.feedback(response.data.message);
      });
    },

    warningSaleRemove(sale) {
      this.$data.sale = sale;
      this.$data.saleRemoveWarning = true;
    },
  },
};
</script>
<style type="text/css">
.v-list {
  padding: 0;
}
</style>
